export const GET_SHIFT_TYPES = "GET_SHIFT_TYPES";

export const GET_STAFFS_WITHOUT_DEPT = "GET_STAFFS_WITHOUT_DEPT";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_COUNT = "GET_NOTIFICATIONS_COUNT";
export const MARK_AS_READ = "MARK_AS_READ";

export const GET_PATIENT = "GET_PATIENT";
export const GET_GENOTYPE = "GET_GENOTYPE";
export const GET_BLOOD_GROUP = "GET_BLOOD_GROUP";
export const GET_PATIENTS = "GET_PATIENTS";
export const GET_EMERGENCY_PATIENTS = "GET_EMERGENCY_PATIENTS";
export const DISCHARGE_PATIENT = "DISCHARGE_PATIENT";
export const GET_PATIENT_ADMISSION_LIST = "GET_PATIENT_ADMISSION_LIST";
export const SCHEDULE_DISCHARGE = "SCHEDULE_DISCHARGE";
export const GET_PATIENT_VISITS = "GET_PATIENT_VISITS";
export const PATIENTS_EXTERNAL_MEDICAL_REDCORDS =
  "PATIENTS_EXTERNAL_MEDICAL_REDCORDS";
export const GET_PATIENT_RECENT_VISIT = "GET_PATIENT_RECENT_VISIT";
export const VITAL_SIGNS_GRAPH = "VITAL_SIGNS_GRAPH";
export const GET_PATIENT_RECENT_VISIT_ITEM = "GET_PATIENT_RECENT_VISIT_ITEM";
export const GET_PATIENT_PACKAGE = "GET_PATIENT_PACKAGE";
export const SEARCH_PATIENT = "SEARCH_PATIENT";
export const GET_PATIENTS_DISCHARGE_LIST = "GET_PATIENTS_DISCHARGE_LIST";
export const PATIENTS_SERVICE_REPORT = "PATIENTS_SERVICE_REPORT";
export const GET_SINGLE_VISIT = "GET_SINGLE_VISIT";
export const SEARCH_BATCH = "SEARCH_BATCH";
//laboratory
export const GET_TEST_LIST = "GET_TEST_LIST";
export const GET_ALL_STOCK_ITEMS = "GET_ALL_STOCK_ITEMS";
export const GET_LAB_EXPORT_DATA = "GET_LAB_EXPORT_DATA";

//pharmacy
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SEARCH_PRESCRIPTION = "SEARCH_PRESCRIPTION";
export const GET_DISPENSED_LIST = "GET_DISPENSED_LIST";
export const GET_EXPIRED_DRUGS = "GET_EXPIRED_DRUGS";
export const GET_ALL_REQUEST = "GET_ALL_REQUEST";
export const GET_ALL_REQUEST_LIST = "GET_ALL_REQUEST_LIST";
export const GET_ALL_DISPENSED_REQUEST = "GET_DISPENSED_REQUEST";

//department inventory
export const GET_ALL_DEPARTMENT_INVENTORY = "GET_ALL_DEPARTMENT_INVENTORY";
export const GET_INVENTORY_OVERVIEW_DATA = "GET_INVENTORY_OVERVIEW_DATA";
export const GET_ALL_ITEM_TYPES = "GET_ALL_ITEM_TYPES";
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_REQUISITION_HISTORY = "GET_REQUISITION_HISTORY";
export const GET_USAGE_HISTORY = "GET_USAGE_HISTORY";
export const GET_INVENTORY_PRODUCT_BATCHES = "GET_INVENTORY_PRODUCT_BATCHES";
export const GET_INVENTORY_PRODUCT_BATCH = "GET_INVENTORY_PRODUCT_BATCH";

//accounting
export const GET_PENDING_REQUEST = "GET_PENDING_REQUEST";
export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const GET_ACCOUNTING_REPORTS = "GET_ACCOUNTING_REPORTS";
export const GET_ACCOUNTING_REPORTS_PAYMENT_METHOD =
  "GET_ACCOUNTING_REPORTS_PAYMENT_METHOD";
export const GET_ALL_PENDING_TRANSACTIONS = "GET_ALL_PENDING_TRANSACTIONS";
export const GET_ALL_PAID_TRANSACTIONS = "GET_ALL_PAID_TRANSACTIONS";
export const GET_TRANSACTIONS_REFERENCE = "GET_TRANSACTIONS_REFERENCE";
export const GET_ALL_PENDING_TRANSACTIONS_FOR_PATIENT =
  "GET_ALL_PENDING_TRANSACTIONS_FOR_PATIENT";
export const GENERATE_RECEIPTS = "GENERATE_RECEIPTS";
export const GET_ACCOUNTING_DETAILS = "GET_ACCOUNTING_DETAILS";
export const GET_LINE_CHART_DATA = "GET_LINE_CHART_DATA";
export const GET_TRANSACTION_TYPES = "GET_TRANSACTION_TYPES";
export const GET_PACKAGES = "GET_PACKAGES";

export const GET_ACCOUNTING_REQUISITIONS = "GET_ACCOUNTING_REQUISITIONS";
export const GET_ACCOUNTING_REQUISITION_DISPUTE =
  "GET_ACCOUNTING_REQUISITION_DISPUTE";
export const GET_ALL_DISPUTES = "GET_ALL_DISPUTES";

//HMO

export const GET_HMOS = "GET_HMOS";

//appointments
export const GET_ALL_APPOINTMENTS = "GET_ALL_APPOINTMENTS";
export const GET_ALL_APPOINTMENTS_BY_PATIENT =
  "GET_ALL_APPOINTMENTS_BY_PATIENT";
export const GET_UPCOMING_APPOINTMENTS_BY_PATIENT =
  "GET_UPCOMING_APPOINTMENTS_BY_PATIENT";
export const GET_PATIENT_APPOINTMENT_HISTORY =
  "GET_PATIENT_APPOINTMENT_HISTORY";
export const GET_RUNNING_APPOINTMENT_BY_PATIENT =
  "GET_RUNNING_APPOINTMENT_BY_PATIENT";

//dashboards
export const GET_PENDING_DISCHARGE = "GET_PENDING_DISCHARGE";

export const GET_AVAILABLE_DOCTORS = "GET_AVAILABLE_DOCTORS";
export const GET_DOCTOR_STAT = "GET_DOCTOR_STAT";
export const GET_PATIENT_INVESTIGATION = "GET_PATIENT_INVESTIGATION";
export const GET_PATIENT_PRESCRIPTIONS = "GET_PATIENT_PRESCRIPTIONS";

export const GET_DEPARTMENTS = "GET_DEPARTMENTS";

export const GET_TESTS = "GET_TESTS";

export const GET_PHARMACIES = "GET_PHARMACIES";
export const GET_ALL_PHARMACY_PRODUCTS = "GET_ALL_PHARMACY_PRODUCTS";
export const GET_ALL_PHARMACY_REQUISITIONS = "GET_ALL_PHARMACY_REQUISITIONS";

export const GET_ALL_INVENTORY_PRODUCTS = "GET_ALL_INVENTORY_PRODUCTS";
export const GET_ALL_INVENTORY_REQUISITIONS = "GET_ALL_INVENTORY_REQUISITIONS";

export const GET_ALL_NEW_VENDORS = "GET_ALL_NEW_VENDORS";

export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
export const GET_STAT_FOR_SINGLE_DEPARTMENT = "GET_STAT_FOR_SINGLE_DEPARTMENT";

export const GET_FOLLOWUP_APPOINTMENTS = "GET_FOLLOWUP_APPOINTMENTS";
export const GET_GENERALIST_APPOINTMENTS = "GET_GENERALIST_APPOINTMENTS";
export const GET_SPECIALIST_APPOINTMENTS = "GET_SPECIALIST_APPOINTMENTS";
export const GET_SPECIALIST_APPOINTMENTS_BY_DOC =
  "GET_SPECIALIST_APPOINTMENTS_BY_DOC";
export const GET_APPOINTMENT_HISTORY = "GET_APPOINTMENT_HISTORY";
export const SEARCH_STAFF = "SEARCH_STAFF";
export const GET_STAFFS = "GET_STAFFS";
export const GET_STAFF = "GET_STAFF";
export const TRANSFER_STAFF = "TRANSFER_STAFF";
export const GET_ROLES = "GET_ROLES";
export const GET_ROLE_DESIGNATIONS = "GET_ROLE_DESIGNATIONS";
export const GET_DESIGNATIONS = "GET_DESIGNATIONS";
export const GET_DESIGNATION = "GET_DESIGNATION";

export const GET_WARDS = "GET_WARDS";
export const GET_WARD = "GET_WARD";
export const GET_STAFS_IN_A_WARD = "GET_STAFS_IN_A_WARD";
export const DELETE_WARD = "DELETE_WARD";

export const GET_CLINIC = "GET_CLINIC";
export const GET_CLINICS = "GET_CLINICS";
export const DELETE_CLINIC = "DELETE_CLINIC";

export const GET_UNITS = "GET_UNITS";
export const GET_UNIT = "GET_UNIT";
export const DELETE_UNIT = "DELETE_UNIT";

export const GET_SCHEDULES = "GET_SCHEDULES";

export const SEARCH_STAFFS_BY_UNIT = "SEARCH_STAFFS_BY_UNIT";
export const SEARCH_STAFFS_BY_WARD = "SEARCH_STAFFS_BY_WARD";

export const GET_ALL_STOCKS = "GET_ALL_STOCKS";
export const GET_REQUEST_HISTORY = "GET_REQUEST_HISTORY";
export const STOCK_REQUEST = "STOCK_REQUEST";

export const GET_INVESTIGATION_TESTS = "GET_INVESTIGATION_TESTS";
export const GET_TEST_INFO = "GET_TEST_INFO";
export const GET_DRUG_TYPES = "GET_DRUG_TYPES";
export const GET_PHARMACY_GENERICS = "GET_PHARMACY_GENERICS";
export const GET_INVESTIGATION_TEST_STATS = "GET_INVESTIGATION_TEST_STATS";

export const LAB_HISTORY = "LAB_HISTORY";
export const GET_LAB_UPCOMING_INVESTIGATIONS =
  "GET_LAB_UPCOMING_INVESTIGATIONS";

// Radiology
export const GET_RADIOLOGY_UPCOMING_INVESTIGATIONS =
  "GET_RADIOLOGY_UPCOMING_INVESTIGATIONS";
export const RADIOLOGY_HISTORY = "RADIOLOGY_HISTORY";
export const RADIOLOGY_STOCK_HISTORY = "RADIOLOGY_STOCK_HISTORY";
export const GET_RADIOLOGY_STOCKS = "GET_RADIOLOGY_STOCKS";
export const GET_RADIOLOGY_STOCK_UNITS = "GET_RADIOLOGY_STOCK_UNITS";
export const GET_RADIOLOGY_EXPORT_DATA = "GET_RADIOLOGY_EXPORT_DATA";
export const GET_RADIOLOGY_TEST_INFO = "GET_RADIOLOGY_TEST_INFO";

export const GET_PHARMACY_DISPENSE_HISTORY = "GET_PHARMACY_DISPENSE_HISTORY";
export const GET_ONE_PRODUCT_DETAILS = "GET_ONE_PRODUCT_DETAILS";
export const GET_LAB_STOCKS = "GET_LAB_STOCKS";
export const GET_LAB_STOCK_UNITS = "GET_LAB_STOCK_UNITS";

export const SEARCH_INVENTORY_ITEMS = "SEARCH_INVENTORY_ITEMS";

export const GET_NURSE_DASHBOARD_STATS = "GET_NURSE_DASHBOARD_STATS";
//admin Dashboard
export const GET_HOSPITAL_DETAILS = "GET_HOSPITAL_DETAILS";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_ACCOUNTING_REVENUE = "GET_ACCOUNTING_REVENUE";
export const GET_ADMIN_DASHBOARD_ANALYTICS = "GET_ADMIN_DASHBOARD_ANALYTICS";
export const GET_NURSE_DASHBOARD_ASSESSMENT_LOGS =
  "GET_NURSE_DASHBOARD_ASSESSMENT_LOGS";
//settings
export const GET_ROLES_FOR_USERS = "GET_ROLES_FOR_USERS";
export const GET_SAMPLE_STANDARDS = "GET_SAMPLE_STANDARDS";
